import PropTypes from 'prop-types';

const BasicQuestionDataType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
  })
);

const SingleSelectQuestionDataType = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    percentage: PropTypes.number.isRequired,
  })
);

const OrderedQuestionDataType = PropTypes.shape({
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      score: PropTypes.string.isRequired,
    })
  ),
  values: PropTypes.arrayOf(
    PropTypes.shape({
      rank: PropTypes.number.isRequired,
      optionId: PropTypes.number.isRequired,
      count: PropTypes.number.isRequired,
      percentage: PropTypes.number.isRequired,
    })
  ),
});

const MatrixQuestionDataType = PropTypes.shape({
  weights: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          weightId: PropTypes.number,
          count: PropTypes.number.isRequired,
          percentage: PropTypes.number.isRequired,
        })
      ).isRequired,
    })
  ),
});

const GeolocationQuestionDataType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    comment: PropTypes.string,
  })
);

const ImageQuestionDataType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    comment: PropTypes.string,
  })
);

const LocationType = PropTypes.shape({
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
});

const EngagementReportQuestionType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  chartType: PropTypes.string,
  display: PropTypes.bool,
  showDataTable: PropTypes.bool,
  summaryNotes: PropTypes.string,
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.string,
    })
  ),
  imageUrl: PropTypes.string,
  analysis: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      word: PropTypes.string,
    })
  ),
  location: LocationType,
  data: PropTypes.oneOfType([
    BasicQuestionDataType,
    SingleSelectQuestionDataType,
    OrderedQuestionDataType,
    MatrixQuestionDataType,
    GeolocationQuestionDataType,
    ImageQuestionDataType,
  ]).isRequired,
});

const EngagementReportSectionType = PropTypes.shape({
  position: PropTypes.number.isRequired,
  title: PropTypes.string,
  questions: PropTypes.arrayOf(EngagementReportQuestionType),
});

const EngagementReportType = PropTypes.shape({
  createdAt: PropTypes.string.isRequired,
  snapshot: PropTypes.shape({
    engagement: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
    sections: PropTypes.arrayOf(EngagementReportSectionType),
  }).isRequired,
});

const ResultsSummaryType = PropTypes.shape({
  language: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  introduction: PropTypes.string,
  conclusion: PropTypes.string,
  filterOptions: PropTypes.shape({}),
  visibility: PropTypes.string.isRequired,
  engagement: PropTypes.shape({
    respondedSubmissionsCount: PropTypes.number,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
  }),
  engagementSummary: PropTypes.shape({
    startTime: PropTypes.string.isRequired,
    endTime: PropTypes.string,
    started: PropTypes.number.isRequired,
    startedWithResponses: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    responseCount: PropTypes.number.isRequired,
  }).isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.number.isRequired,
      title: PropTypes.string,
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          chartType: PropTypes.string,
          displayType: PropTypes.string.isRequired,
          showDataTable: PropTypes.bool.isRequired,
          data: PropTypes.shape({}).isRequired,
        })
      ),
    })
  ),
});

export {
  BasicQuestionDataType,
  SingleSelectQuestionDataType,
  OrderedQuestionDataType,
  MatrixQuestionDataType,
  GeolocationQuestionDataType,
  ImageQuestionDataType,
  EngagementReportType,
  EngagementReportSectionType,
  EngagementReportQuestionType,
  LocationType,
  ResultsSummaryType,
};
